import { render, staticRenderFns } from "./DashboardParticipant.vue?vue&type=template&id=be7a6f52&scoped=true&"
import script from "./DashboardParticipant.vue?vue&type=script&lang=js&"
export * from "./DashboardParticipant.vue?vue&type=script&lang=js&"
import style0 from "./DashboardParticipant.vue?vue&type=style&index=0&id=be7a6f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7a6f52",
  null
  
)

export default component.exports